import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { map } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { AddedEntity } from '../../../shared/models/api-results/base.api-result';
import {
  AddExamContentPayload,
  UpdateExamContentPayload,
} from '../../../shared/models/payloads/exam-content.payload';
import { ExamContentResult } from '../../../shared/models/api-results/exam-content.api-result';
import { UpdatePriorityPayload } from '../../../shared/models/payloads/priority.payload';
import { ListRatesResult } from '../../../shared/models/api-results/rate.api-result';
import { QueryData } from '../../../shared/models/payloads/query-data.payload';
import { prepareQueryParams } from '../../../shared/utils/api-transformations';
import { ExamContentRatePayload } from '../../../shared/models/payloads/rate.payload';
import { ListUniversitiesResult } from '../../../shared/models/api-results/university.api-result';
import { ListExamSessionsResult } from '../../../shared/models/api-results/exam-session.api-result';
import {
  ExamContentStudentsRankingQueryData,
  ExamStudentsRankingQueryData,
} from '../../../shared/models/payloads/exam.payload';

@Injectable({
  providedIn: 'root',
})
export class HttpExamContentService {
  constructor(private http: HttpClient) {}

  rate(payload: ExamContentRatePayload) {
    return this.http.post(
      `${environment.api_base_url}/exam_content_rates/rate_exam_content`,
      payload
    );
  }

  // nnkitodo [v2later] il semblerait que la sécurité sur rankingAvailableAt ne marche pas
  listStudentsRanking(id: string, params: ExamContentStudentsRankingQueryData) {
    return this.http
      .get(
        `${environment.api_base_url}/exam_contents/${id}/list_student_rankings_of_an_exam_content`,
        {
          params: prepareQueryParams(params),
        }
      )
      .pipe(
        map((res: any) => {
          // nnkitodo [v2later] fix api
          res['hydra:member'].map((elt) => {
            if (elt.graduationName && elt.examSession) {
              elt.examSession.graduationName = elt.graduationName;
            }
            if (elt.university && elt.examSession) {
              elt.examSession.university = elt.university;
            }
            return elt;
          });
          return res;
        }),
        map((res) => res as ListExamSessionsResult)
      );
  }

  listUniversitiesRanking(id: string, params: QueryData) {
    return this.http
      .get(
        `${environment.api_base_url}/exam_contents/${id}/get_university_rankings_of_an_exam_content`,
        {
          params: prepareQueryParams(params),
        }
      )
      .pipe(map((res) => res as ListUniversitiesResult));
  }

  wGet(id: string) {
    return this.http
      .get(`${environment.api_base_url}/exam_contents/${id}/exam_content_details`)
      .pipe(map((res) => res as ExamContentResult));
  }

  wAdd(payload: AddExamContentPayload) {
    return this.http
      .post(`${environment.api_base_url}/exam_contents/add_exam_content`, payload)
      .pipe(map((res) => res as AddedEntity));
  }

  wDelete(id: string) {
    return this.http.post(
      `${environment.api_base_url}/exam_contents/${id}/soft_delete_exam_content`,
      {}
    );
  }

  wUpdate(id: string, payload: UpdateExamContentPayload) {
    return this.http.post(
      `${environment.api_base_url}/exam_contents/${id}/update_exam_content`,
      payload
    );
  }

  wUpdatePriority(id: string, payload: UpdatePriorityPayload) {
    return this.http.post(
      `${environment.api_base_url}/exam_contents/${id}/update_exam_content_priority`,
      payload
    );
  }

  wResetAverageRating(id: string) {
    return this.http.post(
      `${environment.api_base_url}/exam_contents/${id}/reset_exam_content_rates`,
      {}
    );
  }

  wListExamContentRates(id: string, params: QueryData) {
    return this.http
      .get(
        `${environment.api_base_url}/exam_content_rates/${id}/list_commented_ratings_exam_content`,
        {
          params: prepareQueryParams(params),
        }
      )
      .pipe(map((res) => res as ListRatesResult));
  }
}
